<template>
  <div class="section" style="padding: 20px 20px 10px 20px">
    <el-form :disabled="!isEdit" :inline="true" label-width="90px" label-position="left">
      <el-form-item label="Airline Code">
        <cargo-advance-select
          no="airlineCode"
          filterable
          :static-options="iataCodeList"
          :default-value="form.airlineCode"
          tag-value="iataCode"
          tag-name="iataCode"
          :filter-tag-names="['iataCode']"
          style="width: 350px"
          @parentCallBack="p => {form.airlineCode=p.value}"
        />
      </el-form-item>
      <el-form-item label="MAWB Prefix">
        <el-input v-model="form.mawbprefix" no="mawbprefix" style="width: 350px" />
      </el-form-item>
    </el-form>
    <div class="grid-view">
      <div class="main-content">
        <div class="operations" style="margin-bottom: 5px">
          <div class="triggers">
            <div>
              <el-button
                no="new"
                :disabled="!isEdit"
                type="primary"
                @click="showEditDialog(true)"
              >{{ $t('common.btn.new') }}</el-button>
              <el-button
                no="edit"
                :disabled="!isEdit"
                type="primary"
                @click="showEditDialog(false)"
              >{{ $t('common.btn.edit') }}</el-button>
              <el-button no="add" :disabled="!isEdit" type="primary" @click="showChargeDialog">Add Charge</el-button>
              <el-button no="delete" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
            </div>
          </div>
        </div>
        <div class="grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="140px" label-position="left">
          <el-form-item label="Office">
            <cargo-advance-select
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office"
              filterable
              :callback-params="{key:'branchId'}"
              callback-method-type="value"
              :default-value="editDialog.form.branchId"
              :clearable="false"
              style="width:205px;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
          <el-form-item label="Scheme Name">
            <el-input v-model="editDialog.form.schemeName" no="schemeName" />
          </el-form-item>
          <el-form-item label="IATA Code">
            <el-input v-model="editDialog.form.iataCode" no="iataCode" />
          </el-form-item>
          <el-form-item label="Account Code">
            <el-input v-model="editDialog.form.accountNo" no="accountNo" />
          </el-form-item>
          <el-form-item label="Insured Amount">
            <el-input v-model="editDialog.form.insuredAmount" no="insuredAmount" />
          </el-form-item>
          <el-form-item label="Carrier Agent City">
            <el-input v-model="editDialog.form.carrierAgentCity" no="carrierAgentCity" />
          </el-form-item>
          <el-form-item label="Issued By">
            <el-input v-model="editDialog.form.issuedBy" no="issuedBy" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item label="Handling Info">
            <el-input v-model="editDialog.form.handingInfo" no="handingInfo" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item label="Account Info">
            <el-input v-model="editDialog.form.accountInfo" no="accountInfo" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 合并弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeDialogVisible"
      title="Add Other Charge"
      width="950px"
      :close-on-click-modal="false"
    >
      <mawb-info-other-charge ref="mawbInfoOtherCharge" />
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import mawbInfoOtherCharge from './mawbInfoOtherChargeForm'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getAirlineList } from '@/api/partner/airline'
import { getAllAirline } from '@/api/airport'
import { getMAWBInfoList } from '@/api/partner/mawbInfo'

export default {
  name: 'AirlineForm',
  components: { cargoAdvanceSelect, mawbInfoOtherCharge },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      form: {},
      filter: {
        airlineUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: 'Office',
          field: 'branchId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: 'Scheme Name',
          field: 'schemeName',
          width: 200
        }, {
          headerName: 'IATA Code',
          field: 'iataCode',
          width: 200
        }, {
          headerName: 'Account No',
          field: 'accountNo',
          width: 200
        }, {
          headerName: 'Insured Amount',
          field: 'insuredAmount',
          width: 200
        }, {
          headerName: 'Issued By',
          field: 'issuedBy',
          width: 200
        }, {
          headerName: 'Carrier Agent City',
          field: 'carrierAgentCity',
          width: 200
        }, {
          headerName: 'Account Info',
          field: 'accountInfo',
          width: 200
        }, {
          headerName: 'Handling Info',
          field: 'handingInfo',
          width: 200
        }
      ],
      rowData: [],
      deletedMAWBInfoKeys: [],
      editDialog: {
        visible: false,
        title: '',
        form: {}
      },
      chargeDialogVisible: false,
      autoIncrementNum: new AutoIncrementNum(),
      iataCodeList: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        await this.getForm(row.uuid)
        if (this.form.uuid) {
          this.filter.airlineUuid = this.form.uuid
          this.toQuery()
        } else {
          this.rowData = []
        }
        this.deletedMAWBInfoKeys = []
        this.getIataCodeList()
      }
    },
    async getForm(companyUuid) {
      await getAirlineList({ companyUuid }).then(res => {
        if (res.data.list.length > 0) {
          this.form = res.data.list[0]
        } else {
          this.form = {
            uuid: '',
            airlineCode: '',
            mawbprefix: '',
            companyUuid: companyUuid
          }
        }
      })
    },
    getSubmitData() {
      this.form.mawbInfos = this.rowData
      this.form.deletedMAWBInfoKeys = this.deletedMAWBInfoKeys
      return {
        airlineDetail: this.form
      }
    },
    toQuery() {
      const filter = this.filter
      getMAWBInfoList(filter).then(res => {
        res.data.list.forEach(item => {
          item.seq = this.autoIncrementNum.getNextNum()
        })
        this.rowData = res.data.list
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          branchId: this.$store.getters.currentOfficeId,
          schemeName: '',
          iataCode: '',
          accountNo: '',
          insuredAmount: '',
          carrierAgentCity: '',
          issuedBy: '',
          handingInfo: '',
          accountInfo: '',
          airlineUuid: this.form.uuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const row = this.getSelectedRow()
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      if (!this.editDialog.form.insuredAmount) {
        this.editDialog.form.insuredAmount = 'NIL'
      }
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    showChargeDialog() {
      const row = this.getSelectedRow()
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.$refs.mawbInfoOtherCharge) {
        this.$refs.mawbInfoOtherCharge.onShow(row)
      } else {
        setTimeout(() => {
          this.$refs.mawbInfoOtherCharge.onShow(row)
        })
      }
      this.chargeDialogVisible = true
    },
    getSelectedRow() {
      const cell = this.gridApi.getFocusedCell()
      if (cell) {
        const node = this.gridApi.rowModel.rowsToDisplay[cell.rowIndex]
        if (node) {
          return node.data
        }
      }
      return null
    },
    saveSub() {
      const self = this
      const form = self.editDialog.form
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      self.editDialog.visible = false
    },
    remove() {
      const self = this
      const row = this.getSelectedRow()
      if (!row) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedMAWBInfoKeys.push(row.uuid)
        }
      }).catch(() => { })
    },
    // 获取所有航空公司代码，用于iataCode的下拉框
    getIataCodeList() {
      getAllAirline().then(res => {
        this.iataCodeList = res.data
        if (!this.iataCodeList.some(item => item.iataCode === this.form.airlineCode) && this.form.airlineCode !== '') {
          this.iataCodeList.push({ iataCode: this.form.airlineCode })
        }
      })
    }
  }
}
</script>

<style>
</style>
